import { FETCH_DROPXL_LOGS, CLEAN_DROPXL_LOGS } from '../actions/types';

const DROPXL_LOGS_DEFAULT_STATE = {};

const DropxlLogsReducer = (state = DROPXL_LOGS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_DROPXL_LOGS:
            return payload;

        case CLEAN_DROPXL_LOGS:
            return DROPXL_LOGS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default DropxlLogsReducer;
